import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import countries from '@constants/countries'

export default class ShipSanitationExtension extends React.Component {
  resource = 'moen/health/ship_sanitation_extensions'
  form_key = 'ship_sanitation_extension'
  defaults = {}

  // Delete lines as needed
  fee = 99
  free = true
  postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = []

  validate = null

  foremost = null

  fields = form => [

    {
        name: "scanned_cert",
        label: "Scanned Copy of Certificate",
        type: "file:all",
        key: "image.0"
    },
    {
        name: "cert_number",
        label: "Certificate #",
        type: "integer",
    },
    {
        name: "inspect_date",
        label: "Inspection Date",
        type: "date",
        showDropdownYear: true,
        showDropdownMonth: true,
    },
    {
        name: "ship_name",
        label: "Name of Ship/Vessel"
    },
    {
        name: "flag",
        options: countries,
        hint: 'Country where the ship is registered'
    },
    {
        name: "reg_number",
        label: "Registration/IMO #",
        type: "integer",
    },

  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
